import React from 'react';
import {  View, Text, TouchableOpacity, FlatList, Dimensions, StyleSheet } from 'react-native';
import { Modal } from '@material-ui/core';



const TenantModal = ({ isVisible, onClose, onProceed, onSelectTenant,data }) => {

    const getLeadT =(row)=>{
        const leadTenant = row?.tenants.find((tenant) => tenant?.is_lead)
        if (leadTenant) {
          return (
            <>
              {leadTenant?.app_user?.user?.first_name} {leadTenant?.app_user?.user?.last_name}
            </>
          )
        } else {
          return 'N/A'
        }
    }
const { height } = Dimensions.get('window');
  return (
    <Modal
    
    open={isVisible ? isVisible : false}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: 10,
      paddingRight: 10,
      flex:1
    }}
   >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <Text style={styles.title}>Following flo's are already active for this property</Text>
          <Text style={styles.subtitle}>
            Select one of the existing tenants and click "continue" to onboard an existing tenant,
            or to onboard a new tenant, select "start new flo"
          </Text>

          {/* Table Header */}
          <View style={styles.tableHeader}>
            <Text style={styles.headerText}>LEAD TENANT</Text>
            <Text style={styles.headerText}>COMPLETED</Text>
            <Text style={styles.headerText}>ACTION</Text>
          </View>

          {/* Table Body */}
         {data&&data.length? <FlatList
            data={data}
            keyExtractor={(item) => item.id}
            contentContainerStyle={{maxHeight:(height-300),overflow:"scroll"}}
            renderItem={({ item }) => (
              <View style={styles.tableRow}>
                <Text style={styles.cell}>{getLeadT(item)}</Text>
                <Text style={styles.cell}>{item?.percentage_completed? item?.percentage_completed :"0" }%</Text>
                <TouchableOpacity
                  style={styles.continueButton}
                  onPress={() => onSelectTenant(item)}
                >
                  <Text style={styles.continueText}>CONTINUE</Text>
                </TouchableOpacity>
              </View>
            )}
          />:null
}
          {/* Footer Buttons */}
          <View style={styles.footer}>
            <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
              <Text style={styles.cancelText}>CANCEL</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.startButton} onPress={onProceed}>
              <Text style={styles.startText}>START NEW FLO</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default TenantModal;
const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    padding: 20,
    backgroundColor: 'white',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowRadius: 5,
    elevation: 5,
    margin: 20,

  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: '#7e57c2', // Purple
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    color: '#555',
    marginBottom: 16,
  },
  tableHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
    paddingBottom: 8,
    marginBottom: 8,
  },
  headerText: {
    flex: 1,
    fontWeight: '600',
    fontSize: 13,
    color: '#666',
    textAlign: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 12,
    borderBottomColor: '#eee',
    borderBottomWidth: 1,
    alignItems: 'center',
  },
  cell: {
    flex: 1,
    textAlign: 'center',
    color: '#333',
  },
  continueButton: {
    flex: 1,
    backgroundColor: '#35b1c8',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    marginHorizontal: 4,
  },
  continueText: {
    color: '#fff',
    fontWeight: '600',
    textAlign: 'center',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 16,
  },
  cancelButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderColor: '#d81b60',
    borderWidth: 1,
    borderRadius: 6,
    marginRight: 10,
  },
  cancelText: {
    color: '#d81b60',
    fontWeight: '600',
  },
  startButton: {
    backgroundColor: '#7e57c2',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 6,
  },
  startText: {
    color: '#fff',
    fontWeight: '600',
  },
});
